/* eslint-disable max-classes-per-file */
import { QuestionModel } from 'core/models/elements/questions/question.abstract.model';
import { ChoiceModel } from 'core/models/elements/components/choice.model';

/**
 * @class Defines a sorting question.
 */
export class SortingQuestionModel extends QuestionModel {
  /**
   * @constructor Creates an instance of a sorting question built from an original data from the API.
   * @param {bo} bo is the basic object come from API.
   */
  constructor(bo) {
    super(bo);
    this.sortTags = bo.sort_tags
      ? bo.sort_tags.map((item) => new ChoiceModel(item))
      : undefined;
    this.initialItems = bo.initial_items
      ? bo.initial_items.map((item) => new ChoiceModel(item))
      : undefined;
    this.displayMode = bo.display_mode;
  }
}
